import React from 'react';

import { reduxForm } from 'redux-form';
import { get } from 'lodash';
import {
  Row,
  Col,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  FormGroup,
  Collapse,
  Button,
  Label
} from 'reactstrap';
import qs from 'qs';

import states from 'data/us-states';
import serviceAreas from 'data/service-areas';

import CustomInput from 'components/ui/CustomInput';
import Icon from 'components/ui/Icon';
import ChannelIcon from 'components/ui/ChannelIcon';

import { loadCategories } from './actions.js';
import styles from './filters.module.css';

const filters = {
  amount: [
    { value: 'lt_5000', label: '< $5,000' },
    { value: '5000_10000', label: '$5,000 - $10,000' },
    { value: '10000_15000', label: '$10,000 - $15,000' },
    { value: '15000_20000', label: '$15,000 - $20,000' },
    { value: 'gt_20000', label: '> $20,000' }
  ],
  channel: [
    { value: 'twitter', label: 'Twitter' },
    { value: 'facebook', label: 'Facebook' },
    { value: 'pinterest', label: 'Pinterest' },
    { value: 'linkedin', label: 'LinkedIn' },
    { value: 'instagram', label: 'Instagram' },
    { value: 'youtube', label: 'YouTube' },
    { value: 'website', label: 'Website' },
    { value: 'blog', label: 'Blog' },
    { value: 'email', label: 'Email' }
  ],
  reach: [
    { value: 'lt_500', label: '< 500' },
    { value: '500_1000', label: '500 - 1,000' },
    { value: '1000_5000', label: '1,000 - 5,000' },
    { value: '5000_10000', label: '5,000 - 10,000' },
    { value: '10000_15000', label: '10,000 - 15,000' },
    { value: '15000_20000', label: '15,000 - 20,000' },
    { value: 'gt_20000', label: '> 20,000' }
  ]
};

class Filters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: ['asking'],
      categories: []
    };
  }

  componentDidMount() {
    let changed = false;
    const query = qs.parse(document.location.search.slice(1));
    const expanded = ['asking'];

    if (query.filters) {
      const other = ['amount', 'channel', 'reach'];

      other.forEach(o => {
        if (query.filters.hasOwnProperty(o)) {
          changed = true;
          expanded.push(o);
        }
      });

      if (
        query.filters.hasOwnProperty('service_area') ||
        query.filters.hasOwnProperty('states')
      ) {
        expanded.push('location');
      }
    }

    if (changed) {
      this.setState({
        expanded: expanded
      });
    }

    if (this.props.categories.length === 0) {
      loadCategories()(this.props.dispatch);
    }
  }

  doFilter = values => {
    if (!this.props.onFilter) {
      return;
    }

    const query = {
      filters: {
        channel: []
      }
    };

    let filter;
    for (let key in filters) {
      filter = filters[key];

      if (!query.filters.hasOwnProperty(key)) {
        query.filters[key] = [];
      }

      for (let i = 0; i < filter.length; i++) {
        if (this.filterChecked(`${key}.${filter[i].value}`)) {
          query.filters[key].push(filter[i].value);
        }
      }

      if (query.filters[key].length === 0) {
        delete query.filters[key];
      }
    }

    if (values.filters) {
      if (values.filters.category) {
        query.filters.category = values.filters.category;
      } else if (query.filters.category) {
        delete query.filters.category;
      }

      if (values.filters.q) {
        query.filters.q = values.filters.q;
      } else if (query.filters.q) {
        delete query.filters.q;
      }

      if (values.filters.states) {
        query.filters.states = values.filters.states;
      } else if (query.filters.states) {
        delete query.filters.states;
      }

      if (values.filters.service_area) {
        query.filters.service_area = values.filters.service_area;
      } else if (query.filters.service_area) {
        delete query.filters.service_area;
      }
    }

    if (Object.keys(query.filters).length === 0) {
      delete query.filters;
    }

    query.page = 1;
    this.props.onFilter(query);
  };

  resetFilters = () => {
    this.props.reset();
    this.props.onFilter();
  };

  hasFilters = () => {
    if (!this.props.filterForm) {
      return false;
    }

    if (this.props.filterForm.values && this.props.filterForm.values.filters) {
      for (let cat in this.props.filterForm.values.filters) {
        for (let filt in this.props.filterForm.values.filters[cat]) {
          if (this.props.filterForm.values.filters[cat][filt]) {
            return true;
          }
        }
      }
    }

    return false;
  };

  hasFilter = path => {
    if (!path) {
      return false;
    }

    return get(this.props, `initialValues.filters.${path}`, false);
  };

  filterChecked = path => {
    if (!path) {
      return false;
    }

    const formChecked = get(this.props, `filterForm.values.filters.${path}`); //, false);

    if (formChecked !== undefined) {
      return formChecked;
    }

    const [key, value] = path.split('.');
    const query = qs.parse(document.location.search.slice(1));
    const queryParams = get(query, `filters.${key}`, []);

    if (queryParams && queryParams.length > 0) {
      return queryParams.includes(value);
    }

    return false;
  };

  toggleFilter = filter => {
    if (this.props.expandAll) {
      return;
    }

    let expanded = this.state.expanded.slice();
    const pos = expanded.indexOf(filter);

    if (pos > -1) {
      expanded.splice(pos, 1);
    } else {
      expanded.push(filter);
    }

    this.setState({
      expanded: expanded
    });
  };

  hasAnyFilters = category => {
    let filter;
    for (let i = 0; i < filters[category].length; i++) {
      filter = filters[category][i];
      if (this.filterChecked(`${category}.${filter.value}`)) {
        return true;
      }
    }

    return false;
  };

  render() {
    const { handleSubmit, loading } = this.props;

    return (
      <form
        onSubmit={handleSubmit(this.doFilter)}
        className={styles['filters']}
      >
        <FormGroup>
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <Icon icon="search" />
              </InputGroupText>
            </InputGroupAddon>
            <CustomInput
              autoFocus
              placeholder="Search names and descriptions"
              name="filters.q"
            />
          </InputGroup>
        </FormGroup>
        <FormGroup>
          <Label
            className={styles['expandable']}
            onClick={() => this.toggleFilter('asking')}
          >
            Asking Amount
            {!this.props.expandAll && (
              <Icon
                icon={
                  this.state.expanded.indexOf('asking') > -1
                    ? 'angle-up'
                    : 'angle-down'
                }
              />
            )}
          </Label>
          <Collapse
            isOpen={
              this.props.expandAll || this.state.expanded.indexOf('asking') > -1
            }
          >
            <div className={styles['checkboxes']}>
              {filters.amount.map((a, i) => {
                return (
                  <div key={i}>
                    <CustomInput
                      component="checkbox"
                      name={`filters.amount.${a.value}`}
                      checked={this.filterChecked(`amount.${a.value}`)}
                    >
                      {a.label}
                    </CustomInput>
                  </div>
                );
              })}
            </div>
          </Collapse>
        </FormGroup>
        <FormGroup>
          <Label
            className={styles['expandable']}
            onClick={() => this.toggleFilter('channel')}
          >
            Sharing Locations
            {!this.props.expandAll && (
              <Icon
                icon={
                  this.state.expanded.indexOf('channel') > -1
                    ? 'angle-up'
                    : 'angle-down'
                }
              />
            )}
          </Label>
          <Collapse
            isOpen={
              this.props.expandAll ||
              this.state.expanded.indexOf('channel') > -1
            }
          >
            <div className={styles['checkboxes']}>
              {filters.channel.map((f, i) => {
                return (
                  <div key={i}>
                    <CustomInput
                      component="checkbox"
                      name={`filters.channel.${f.value}`}
                      checked={this.filterChecked(`channel.${f.value}`)}
                    >
                      <ChannelIcon channel={{ type: f.value }} />
                      {f.label}
                    </CustomInput>
                  </div>
                );
              })}
            </div>
          </Collapse>
        </FormGroup>
        <FormGroup>
          <Label
            className={styles['expandable']}
            onClick={() => this.toggleFilter('reach')}
          >
            Total Reach
            {!this.props.expandAll && (
              <Icon
                icon={
                  this.state.expanded.indexOf('reach') > -1
                    ? 'angle-up'
                    : 'angle-down'
                }
              />
            )}
          </Label>
          <Collapse
            isOpen={
              this.props.expandAll || this.state.expanded.indexOf('reach') > -1
            }
          >
            <div className={styles['checkboxes']}>
              {filters.reach.map((f, i) => {
                return (
                  <div key={i}>
                    <CustomInput
                      component="checkbox"
                      name={`filters.reach.${f.value}`}
                      /*defaultChecked={this.hasFilter(`reach.${f.value}`)}*/
                      checked={this.filterChecked(`reach.${f.value}`)}
                    >
                      {f.label}
                    </CustomInput>
                  </div>
                );
              })}
            </div>
          </Collapse>
        </FormGroup>
        <FormGroup>
          <Label
            className={styles['expandable']}
            onClick={() => this.toggleFilter('location')}
          >
            Location
            {!this.props.expandAll && (
              <Icon
                icon={
                  this.state.expanded.indexOf('location') > -1
                    ? 'angle-up'
                    : 'angle-down'
                }
              />
            )}
          </Label>
          <Collapse
            isOpen={
              this.props.expandAll ||
              this.state.expanded.indexOf('location') > -1
            }
          >
            <div className="pt-2">
              <Label>Service Area</Label>
              <CustomInput
                component="select"
                name="filters.service_area"
                data={serviceAreas}
                /*defaultValue={this.hasFilter('service_area')}*/
                options={{
                  placeholder: 'All',
                  allowClear: true
                }}
              />
            </div>
            <hr />
            <div className="pb-2">
              <Label>State(s)</Label>
              <CustomInput
                multiple
                component="select"
                name="filters.states"
                data={states}
                /*defaultValue={this.hasFilter('states') || []}*/
                options={{
                  placeholder: 'All States',
                  allowClear: true
                }}
              />
            </div>
          </Collapse>
        </FormGroup>
        {this.props.categories.length > 0 && (
          <FormGroup>
            <Label>Category</Label>
            <CustomInput
              multiple
              component="select"
              name="filters.category"
              options={{
                placeholder: 'All Categories',
                allowClear: true
              }}
              data={this.props.categories.map(c => {
                return { id: c.id, text: c.name };
              })}
            />
          </FormGroup>
        )}
        <Row>
          <Col>
            {this.hasFilters() && (
              <Button
                block
                size="sm"
                color="link"
                onClick={this.resetFilters}
                disabled={loading}
              >
                Reset
              </Button>
            )}
          </Col>
          <Col>
            <Button
              block
              size="sm"
              type="submit"
              color="primary"
              disabled={loading}
            >
              Search
            </Button>
          </Col>
        </Row>
      </form>
    );
  }
}

const reduxFilters = reduxForm({
  form: 'filterForm',
  enableReinitialize: true
})(Filters);

export default reduxFilters;



// WEBPACK FOOTER //
// ./src/components/app/browse/filters.js